var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCloseBlue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#5D5CF5",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18C8.69156 18 6 15.3084 6 12C6 8.69156 8.69156 6 12 6C15.3084 6 18 8.69156 18 12C18 15.3084 15.3084 18 12 18ZM12 6.85712C9.16425 6.85712 6.85712 9.16425 6.85712 12C6.85712 14.8358 9.16425 17.1429 12 17.1429C14.8358 17.1429 17.1429 14.8358 17.1429 12C17.1429 9.16425 14.8358 6.85712 12 6.85712Z",
    fill: "#5D5CF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.143 14.5725C14.0333 14.5725 13.9237 14.5307 13.84 14.4469L9.5543 10.1612C9.38685 9.99378 9.38685 9.7226 9.5543 9.55524C9.72166 9.38788 9.99293 9.38779 10.1603 9.55524L14.446 13.8409C14.6134 14.0084 14.6134 14.2795 14.446 14.4469C14.3623 14.5307 14.2527 14.5725 14.143 14.5725Z",
    fill: "#5D5CF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85725 14.5686C9.74757 14.5686 9.63798 14.5268 9.5543 14.443C9.38685 14.2757 9.38685 14.0044 9.5543 13.837L13.84 9.55137C14.0074 9.38392 14.2786 9.38392 14.446 9.55137C14.6133 9.71873 14.6134 9.99 14.446 10.1574L10.1603 14.443C10.0766 14.5268 9.96693 14.5686 9.85725 14.5686Z",
    fill: "#5D5CF5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/closeBlue.1b966b96.svg";
export { ForwardRef as ReactComponent };